import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { buildKey } from '@yme/utils/common';
import { BorderColStyled, CellTextStyled, CustomBodyRowStyled, CustomHeadRowStyled, TwoColumnsHeaderStyled, } from './styled';
const defaultMaxWidth = {
    sm: 'calc(100% - 152px)',
    md: undefined,
    lg: undefined,
    extraLg: undefined,
};
export function TwoColumnsTable(props) {
    const { firstColumnHeader, description, secondColumnHeader, tableRows, title, isRemoveBottomIndent, } = props;
    const isRightToLeft = useSelector(getRTL);
    if (!tableRows || tableRows.length === 0) {
        return null;
    }
    const bodyData = tableRows?.map((row, index, data) => (React.createElement(Fragment, { key: buildKey(row.firstColumn, index) },
        React.createElement(CustomBodyRowStyled, { justifyContent: "center" },
            React.createElement(Col, { lg: 2, md: 3, customMaxWidth: {
                    ...defaultMaxWidth,
                    sm: '120px',
                } },
                React.createElement(CellTextStyled, { weight: 500 }, row.firstColumn)),
            React.createElement(Col, { lg: 4, md: 5, customMaxWidth: {
                    ...defaultMaxWidth,
                } },
                React.createElement(CellTextStyled, { color: colorCoreBlack300 }, row.secondColumn))),
        data.length > 1 && index === 0 && (React.createElement(Row, { justifyContent: "center" },
            React.createElement(BorderColStyled, { lg: 6, md: 8 }))))));
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, { isRightToLeft: isRightToLeft, dataTestId: "two-columns-table" },
            React.createElement(Row, { justifyContent: "center" },
                React.createElement(Col, { lg: 6, md: 8 },
                    React.createElement(FlexWrapper, { mb: "32px", flexDirection: "column" },
                        title && (React.createElement(TwoColumnsHeaderStyled, { hasDescription: Boolean(description) }, title)),
                        description && React.createElement(CellTextStyled, null, description)))),
            React.createElement(CustomHeadRowStyled, { justifyContent: "center" },
                React.createElement(Col, { lg: 2, md: 3, customMaxWidth: {
                        ...defaultMaxWidth,
                        sm: '120px',
                    } },
                    React.createElement(CellTextStyled, { weight: 500 }, firstColumnHeader)),
                React.createElement(Col, { lg: 4, md: 5, customMaxWidth: {
                        ...defaultMaxWidth,
                    } },
                    React.createElement(CellTextStyled, { weight: 500 }, secondColumnHeader))),
            React.createElement(Row, { justifyContent: "center" },
                React.createElement(BorderColStyled, { lg: 6, md: 8 })),
            bodyData)));
}
TwoColumnsTable.displayName = 'TwoColumnsTable_AEMComponent';
